import { useState } from 'react';
import CheckType from '../CheckType';
import Questions from '../Questions';
import ResultBox from '../ResultBox';
import PlussMobil from '../CollaborationPartner';
import { useAppContext } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { useCmsText } from '../../hooks/useCmsText';

const ResultPage = () => {
  const { state } = useAppContext();
  const navigate = useNavigate();
  const { renderPlainText: renderText  } = useCmsText();
  const [feedback, setFeedback] = useState<string>('');

  return (
    <div className="w-full md:w-2/3 lg:w-1/3 mx-auto flex flex-col px-4 md:px-8 lg:px-12 py-5">
      <ResultBox
        type={state.resultType}
        message={state.resultText}
        caseId={state.caseId}
      />
      
      <div className="w-full flex flex-col mt-10 px-4">
        <button
          onClick={() => navigate('/customer-service')}
          className="mt-4 w-full text-sm font-medium text-white border border-primary rounded-md px-5 py-2 bg-slate-800"
          style={{ background: state.branding?.mainButtonBackground , font: state.branding?.mainButtonFont }}
        >
          {renderText('result_button_customer_service', 'Send til kundeservice')}
        </button>

        <button
          onClick={() => navigate('/')}
          className="mt-4 w-full text-sm font-medium text-slate-800 border border-stone-300 rounded-md px-5 py-2 bg-white"
          style={{ background: state.branding?.mainBackground, font: state.branding?.secondaryButtonFont }}
        >
          {renderText('result_button_check_new', 'Sjekk noe nytt')}
        </button>
      </div>

      {/* <CheckType
        heading={renderText('response_screen_bold_1', 'Var dette nyttig?') as string}
        options={[
          renderText('response_screen_button_yes', 'Ja'),
          renderText('response_screen_button_no', 'Nei'),
          renderText('response_screen_button_unknown', 'Vet ikke')
        ]}
        onSelectOption={(option) => setFeedback(option)}
      /> */}

      {/* <Questions /> */}
      <PlussMobil />
    </div>
  );
};

export default ResultPage;